import React, { useEffect, useRef } from "react";
import gsap from "gsap";

const Layout = ({ children }) => {
  const overlayRef = useRef(null);

  useEffect(() => {
    gsap.to(overlayRef.current, {
      yPercent: -100,
      duration: 1.2,
      ease: "power4.inOut",
      delay: 0.2,
    });
  }, []);

  return (
    <main className="relative w-full h-screen bg-[#050505] flex flex-col overflow-hidden">
      {/* Intro reveal overlay */}
      <div
        ref={overlayRef}
        className="fixed inset-0 z-[100] bg-[#050505] pointer-events-none"
      />
      {children}
    </main>
  );
};

export default Layout;